import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function ServiceList({ AllServicesListing }) {
  // const [services, setService] = useState([]);

  // useEffect(() => {
  //   let ServicesArr = [
  //     {
  //       img: Service01,
  //       title: "Consultation and Diagnostics",
  //       sub: "(Comprehensive 18-point Ayurvedic check-up)",
  //       desc: "Initial Ayurvedic Consultation – A complete 18-point assessment through pulse reading, lifestyle review, and classical Ashtavidha–Dashavidha examination to identify your Prakriti and current imbalances, leading to a personalized plan of diet, lifestyle, Auṣadhi (herbal medicines), and therapies.",
  //     },
  //     {
  //       img: Service02,
  //       title: "Detox & Rejuvenation Programs - Part 1",
  //       sub: "(Panchkarma – Purva Karma)",
  //       desc: "Preparatory phase of Panchkarma with Snehana (oleation), Abhyanga (oil massage), Shirodhara, Swedana, and other therapies to loosen toxins, balance doshas, and prepare the body for deep detoxification.",
  //     },
  //     {
  //       img: Service03,
  //       title: "Detox & Rejuvenation Programs - Part 2",
  //       sub: "( Panchkarma – Pradhan Karma: Shodhana))",
  //       desc: "The core Panchkarma detox with five classical therapies – Vamana (emesis), Virechana (purgation), Basti (enema), Nasya (nasal therapy), and Raktamokshana (blood cleansing). These therapies eliminate deep-seated toxins, balance doshas, relieve stress, and restore vitality.",
  //     },
  //     {
  //       img: Service04,
  //       title: "Detox & Rejuvenation Programs - Part 3",
  //       sub: "(Panchkarma - Paschat Karma: Post-Care & Rejuvenation)",
  //       desc: "Focused on recovery and rejuvenation after detox, this phase includes special diet plans (Sansarjana Krama), Rasayana (rejuvenation therapies), herbal supplements, and guidance on yoga, pranayama, and lifestyle changes. It strengthens immunity, restores energy, and supports long-term well-being.",
  //     },
  //     {
  //       img: Service06,
  //       title: "Therapies & Treatments",
  //       sub: "(Snehana, Swedana & Marma Chikitsa)",
  //       desc: "Experience classical Ayurvedic therapies including Abhyanga oil massage, Shirodhara, Basti, Nasya, Swedana herbal steam, Udvartana powder massage, Netra Basti, and Marma therapy — designed to balance doshas, relieve stress, detoxify, and rejuvenate body and mind.",
  //     },
  //     {
  //       img: Service05,
  //       title: "Wellness & Support Offerings",
  //       sub: "( Swasthavritta & Chikitsa )",
  //       desc: "A holistic blend of preventive and healing practices in Ayurveda, offering diet and lifestyle planning, yoga therapy, meditation, USHA Kriya, and herbal remedies to nurture balance of body, mind, and spirit.",
  //     },
  //     {
  //       img: Service06,
  //       title: "Special Programs",
  //       sub: "( Vishesh Chikitsa )",
  //       desc: "Focused Ayurvedic care programs designed for modern concerns—offering stress and sleep improvement therapies like Shirodhara and meditation, along with pain management through basti, marma therapy, and herbal support.",
  //     },
  //     {
  //       img: Service06,
  //       title: "Traditional Healers & Ancient Wisdom",
  //       sub: "( Lok Parampara & Anushthan )",
  //       desc: "Experience age-old wellness rooted in Indian traditions—Panchgavya therapies, Desi Vaidya consultations, Agni Chikitsa, Gau Shala retreats, and simple home remedies that nurture immunity, balance, and spiritual harmony.",
  //     },
  //     {
  //       img: Service06,
  //       title: "New Service",
  //       sub: "New Service Sub",
  //       desc: "New Sevrice Description",
  //     },
  //   ];

  //   setService(ServicesArr);
  // }, []);

  return (
    <section className="prt-row prt-bg bg-base-grey service-section01 clearfix">
      <div className="container">
        <div
          className="row row-equal-height"
          data-aos="fade-up"
          data-aos-duration="1000"
        >
          {AllServicesListing.map((service, idx) => (
            <div key={idx} className="col-xl-4 col-lg-6 col-md-6 col-sm-6">
              <div className="featured-imagebox featured-imagebox-service style2">
                <div className="featured-thumbnail">
                  <img
                    width="413"
                    height="200"
                    className="img-fluid"
                    src={service.image}
                    alt={service.name}
                  />
                </div>
                <div className="featured-content">
                  <div className="featured-t>itle">
                    <h3>
                      <Link to={service.url}>
                        <a>{service.name}</a>
                      </Link>
                      {/* <span>{service.sub}</span> */}
                    </h3>
                  </div>
                  <div className="featured-desc">
                    <p>{service.serviceListingDesc}</p>
                    <p>
                      <Link to={service.url}>
                        <a className="prt-btn btn-inline prt-btn-color-darkcolor btn-underline">
                          View more
                        </a>
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
